// Material UI
import { makeStyles } from '@material-ui/core'
import Colors from '../../constants/Colors'

export default makeStyles(theme => {
  return {
    Container: {
      display: 'grid',
      gridGap: 24,
      padding: 24,
    },
    increseReasonText: {
      fontFamily: 'Poppins',
      fontSize: '13px',
      color: Colors.SECONDARY_FONT_COLOR,
      letterSpacing: '0',
      paddingTop: '6px',
      display: 'grid',
    },
    priceReasonText: {
      fontFamily: 'Poppins',
      fontSize: '13px',
      color: Colors.SECONDARY_FONT_COLOR,
      letterSpacing: '0',
      paddingTop: '6px',
      display: 'grid',
    },
    textarea: {
      borderColor: Colors.DISABLED_COLOR,
      width: '100%',
    },
    dollarIcon: {
      color: Colors.DISABLED_COLOR,
    },
    headerRoot: {
      [theme.breakpoints.up('md')]: {
        padding: 12,
      },
    },
    footerRoot: {
      borderTop: `1px solid ${Colors.DISABLED_COLOR}`,
    },
    paper: {
      [theme.breakpoints.up('md')]: {
        height: 456,
        width: 557,
        overflowY: 'hidden',
      },
    },
  }
})
